//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportStudentIDsInputItem } from './IReportStudentIDsInputItem';
import { ReportType } from './Enums';

export class StudentDetailsReportInputItem extends ReportInputItem implements IReportStudentIDsInputItem {
    StudentIDs: string[] = [];
    IncludeStudentProfilePicture: boolean = false;
    InclueNoteAboutStudent: boolean = false;
    IncludeNoteAboutParent: boolean = false;
    IncludeBlankLineUnderEachField: boolean = false;
    override readonly Type: ReportType = ReportType.StudentDetails;

    constructor(initializer?: Partial<Omit<StudentDetailsReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentDetailsReportInputItem";
}
